/** @namespace $route.current */
/** @namespace $route.current.params */
module.exports = [
    '$route',
    '$location',
    'CurrentCampaign',
    'AppConstants',
    'CTServiceAPIConfig',
    'DataService',
    function($route, $location, CurrentCampaign, AppConstants, CTServiceAPIConfig, DataService) {
        const _controller = this;

        let _networkActivity = false,
            _showForm = false;

        _controller.campaign = false;

        _controller.isLoaded = () => !!_controller.campaign;
        _controller.isAllowedToEdit = () => !!CurrentCampaign.authCode();


        _controller.toggleForm = () => (_showForm = !_showForm);

        _controller.shouldFormShow = () => _showForm;

        _controller.cancel = () => {
            _showForm = false;
            setTimeout(resetData, 1);
        };

        _controller.submit = () => {
            const authCode = CurrentCampaign.authCode();

            _controller.hasNetworkActivity(true);

            DataService.updateCampaign(_controller.campaign.id, _controller.data, authCode)
                .then((data) => {
                    _controller.campaign.name = data.name;
                    _controller.campaign.description = data.description;
                    _controller.campaign.image_id = data.image_id;
                    _controller.campaign.image_url = data.image_url;
                    _controller.campaign.goal = data.goal;
                    _controller.campaign.goal_enabled = data.goal_enabled;
                    _controller.cancel();
                })
                .finally(() => _controller.hasNetworkActivity(false));
        };

        /**
         * Set network activity when flag is defined
         * Get when flag is not defined
         *
         * @param {boolean} [flag]
         */
        _controller.hasNetworkActivity = (flag) => {
            if(flag === true || flag === false) {
                return (_networkActivity = flag);
            }
            else {
                return _networkActivity;
            }
        };


        _controller.media = {};

        _controller.media.onErrorSujet = (data) => {
            _controller.error.imageSujet = true;
        };
        _controller.media.onUploadSujet = (image_id, image_url) => {
            _controller.data.image_id = image_id;
            _controller.data.image_url = image_url;
        };
        _controller.media.onRemoveSujet = () => {
            _controller.data.image_id = null;
            _controller.data.image_url = null;
        };

        function resetData() {
            console.log(_controller.campaign);
            _controller.data = {
                name: _controller.campaign.name,
                description: _controller.campaign.description,
                image_id: _controller.campaign.image_id,
                image_url: !!_controller.campaign.image ? _controller.campaign.image.lg : null,
                goal: _controller.campaign.goal,
                goal_enabled: !!_controller.campaign.goal_enabled,
            };

            _controller.error = {};

            if(_controller.data.image_url) {
                _controller.headerSujet.setMedia(_controller.data.image_url);
            }
        }

        (function init() {
            setTimeout(() => {
                CurrentCampaign.get()
                    .then((campaign) => (_controller.campaign = campaign))
                    .then(resetData)
            }, 1);
        }());
    },
];
